module.exports = __webpack_public_path__ + "static/media/consumer-to.0fe5fdf5.png";